export class ApiRequestError extends Error {
  constructor(public readonly status: number, public readonly code: string, message: string) {
    super(message);
  }
}

export async function apiRequest<T>(path: string, init: RequestInit = {}, csrfToken?: string): Promise<T> {
  if (import.meta.env.DEV && import.meta.env.MODE !== "test") {
    const { localApiRequest } = await import("./local-api");
    return localApiRequest<T>(path, init);
  }
  const headers = new Headers(init.headers);
  headers.set("accept", "application/json");
  if (init.body && !headers.has("content-type")) headers.set("content-type", "application/json");
  if (csrfToken) headers.set("x-csrf-token", csrfToken);
  const response = await fetch(path, { ...init, headers, credentials: "same-origin" });
  let body: unknown = null;
  try {
    body = await response.json();
  } catch {
    body = null;
  }
  if (!response.ok) {
    const error = getError(body);
    throw new ApiRequestError(response.status, error.code, error.message);
  }
  return body as T;
}

function getError(value: unknown): { code: string; message: string } {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    const error = (value as Record<string, unknown>).error;
    if (error && typeof error === "object" && !Array.isArray(error)) {
      const record = error as Record<string, unknown>;
      return {
        code: typeof record.code === "string" ? record.code : "request_failed",
        message: typeof record.message === "string" ? record.message : "Request failed",
      };
    }
  }
  return { code: "request_failed", message: "Request failed" };
}
